import { createSlice } from "@reduxjs/toolkit";
import { fetchProductionCompany } from "../actions/ProductionCompanyAction";

const productionCompanySlice = createSlice({
  name: "productionCompany",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearProductionCompanies: (state) => {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductionCompany.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProductionCompany.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchProductionCompany.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export const { clearProductionCompanies } = productionCompanySlice.actions;
export default productionCompanySlice.reducer;
